module.exports = __webpack_public_path__ + "dddc30c77897741f934f749e4d252315.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ni.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ni.svg
// module chunks = 0